import React, { Component } from 'react';
import FlickDotLogo from '../images/logo/flick_logo_dot.svg';
import Detector from '../Utilities/OSDetector';
import PlatformInfo from '../models/Platforms';
import PlatformList from './PlatformList';
import { Desktop, Mobile } from '../Utilities/Breakpoints';

class Home extends Component {

    createDownloadButton = () => {
        const detectedOS = Detector();
        console.log("Detected OS: ", detectedOS);
        let platform = PlatformInfo[detectedOS];
        console.log("Offering download for: ", platform);

        let link
        let title

        if (platform == null) {
            // fallback on linux java version
            link = PlatformInfo["linux"].link;
            title = "Download";
        } else if (detectedOS === 'ios' || detectedOS == 'android') {
            link = PlatformInfo["beta-" + detectedOS].link;
            title = "Join the Beta";
        } else {
            link = PlatformInfo[detectedOS].link;
            title = "Download";
        }
        return <a href={link}><button className="btn-join" style={{ cursor: 'pointer' }}>{title}</button></a>;
    }

    render() {

        const headingStyleDesktop = {
            fontFamily: "CircularStd, Arial, sans-serif",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "4.5rem",
            padding: "0rem",
            lineHeight: "71px",
            letterSpacing: "-0.5px",
        }

        const headingStyleMobile = {
            fontFamily: "CircularStd, Arial, sans-serif",
            fontStyle: "normal",
            fontWeight: "bold",
            fontSize: "2rem",
            padding: "0rem",
            lineHeight: "39px",
            letterSpacing: "-0.5px",
        }

        const paraStyleDesktop = {
            padding: "16px 0 0 0",
            fontSize: "1.5rem",
            letterSpacing: "-0.5px",
        }

        const paraStyleMobile = {
            padding: "16px 0 0 0",
            fontSize: "1rem",
            letterSpacing: "-0.5px",
        }

        return (
            <>
                <div className="home">
                    <Desktop>
                        <h1 style={headingStyleDesktop}>Ready.</h1>
                        <h1 style={headingStyleDesktop}>Set.</h1>
                        <img src={FlickDotLogo} alt="Flick Logo" style={{ width: 174, height: 74 }} />
                        <p style={paraStyleDesktop}>Transfer files across any platform<br />with a simple flick.</p>
                    </Desktop>
                    <Mobile >
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "baseline" }}>
                            <h1 style={headingStyleMobile}> Ready. Set.</h1>
                            <img src={FlickDotLogo} alt="Flick Logo" style={{ height: "1.5rem", margin: "0 10px"}} />
                        </div>
                        <p style={paraStyleMobile}>Transfer files with a simple flick.</p>
                    </Mobile>
                    {this.createDownloadButton()}
                    <Desktop>
                        <PlatformList />
                    </Desktop>
                </div>

            </>
        );
    }
}

export default Home;